import { render, staticRenderFns } from "./FormWorkspace.vue?vue&type=template&id=a1cf5086&scoped=true"
import script from "./FormWorkspace.vue?vue&type=script&lang=js"
export * from "./FormWorkspace.vue?vue&type=script&lang=js"
import style0 from "./FormWorkspace.vue?vue&type=style&index=0&id=a1cf5086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf5086",
  null
  
)

export default component.exports